export const CINEMATIC_FRAMES = 90;
export const CINEMATIC_DURATION_MS = 1_500;
export type CinematicStage = 'EMPHASIS' | 'CUT_IN' | 'RESTORE';
export interface CinematicState { readonly id: string; readonly playerSlot: 0 | 1; readonly frame: number; readonly stage: CinematicStage }
export class CinematicController {
  private active: { id: string; playerSlot: 0 | 1; elapsedMs: number } | null = null;
  public start(id: string, playerSlot: 0 | 1): boolean {
    if (this.active !== null) return false; this.active = { id, playerSlot, elapsedMs: 0 }; return true;
  }
  public update(deltaMs: number): { readonly state: CinematicState | null; readonly completedId: string | null } {
    if (this.active === null) return { state: null, completedId: null };
    this.active.elapsedMs += Math.max(0, deltaMs);
    const frame = Math.min(89, Math.floor(this.active.elapsedMs / CINEMATIC_DURATION_MS * CINEMATIC_FRAMES));
    const state = Object.freeze({ id: this.active.id, playerSlot: this.active.playerSlot, frame,
      stage: frame <= 11 ? 'EMPHASIS' as const : frame <= 59 ? 'CUT_IN' as const : 'RESTORE' as const });
    if (this.active.elapsedMs < CINEMATIC_DURATION_MS) return { state, completedId: null };
    const completedId = this.active.id; this.active = null; return { state, completedId };
  }
  public get isActive(): boolean { return this.active !== null; }
  public dispose(): void { this.active = null; }
}
